module.exports = __webpack_public_path__ + "img/分享好友 獲得更多抽獎機會.1f3bff70.png";